import React, { Component } from "react";
import { connect } from "react-redux";

import { AvatarApi } from "services/avatar";
import { UserProfileApi } from "services/userProfile";
import { BloxButton } from "styled_components/Common/BloxButton";
import { logoutUser } from "actions/auth";

class LogoutComponent extends Component {
  constructor(props) {
    super(props);

    this.avatarApi = new AvatarApi();
    this.userProfileApi = new UserProfileApi();
    this.state = {
      currentModule: null,
    };
  }

  getUserName = (user) => {
    const username = this.userProfileApi.getFirstAndLastName(user);

    if (username.length >= 16) {
      return `${username.slice(0, 16)}...`;
    } else {
      return username;
    }
  };
  setExpandedClass = () => {
    const header = document.querySelector(".name");
    header.classList.add("blue-animation");
  };

  removeExpandedClass = () => {
    const header = document.querySelector(".name");
    header.classList.remove("blue-animation");
  };

  logoutUser = () => {
    const { logoutUser, module, navigate } = this.props;
    const logoutButton = document.querySelector(".blox-button.logout");

    if (logoutButton) {
      logoutButton.classList.add(module);
      logoutButton.classList.add("trigger-animation-swipe");
    }
    navigate("/");
    logoutUser();
  };

  render() {
    const { auth_status, module } = this.props;

    return (
      <div
        data-cy="logout-component"
        className="logout-component"
        onMouseOver={this.setExpandedClass}
        onMouseOut={this.removeExpandedClass}
      >
        <div className="avatar">
          <img src={this.avatarApi.getUserAvatar(auth_status)} />
        </div>
        <div className="name header10" data-cy="username">
          {this.getUserName(auth_status)}
        </div>
        <div className="logout-dropdown-container" />
        <div className="hover-wrapper">
          <div className="header-wrapper" />
          <div className="avatar">
            <img src={this.avatarApi.getUserAvatar(auth_status)} />
          </div>
          <div className="name header11">{this.getUserName(auth_status)}</div>

          <div className="logout-button-container">
            <BloxButton
              className="buttons41"
              id="okay"
              text="LOGOUT"
              module={module}
              enabled={true}
              onClick={this.logoutUser}
              cypressId="logout-button"
            />
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
  };
}

export default connect(mapStateToProps, { logoutUser })(LogoutComponent);
